import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../core/breadcrumbs";
import CustomerModal from "../../core/modals/peoples/customerModal";
import CustomerTable from "./customerTable";
import { searchCustomer } from "../../service/ApiServices";

const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const [selectedCustomer, setSelectedCustomer] = useState([]);
  useEffect(() => {
    // fetchCustomers();
    searchCustomer(searchQuery, page).then((value) => {
      setCustomers(value.data.docs);

      setTotal(value.data.totalDocs);
    });
  }, [searchQuery, page]);

  const changePage = async (pagination) => {
    const newPage = pagination.current;  
    setPage(newPage);
  
    let axiosResponse = await searchCustomer(searchQuery, newPage);
    setCustomers(axiosResponse.data.docs);
    setTotal(axiosResponse.data.totalDocs);
  };
  


  // const fetchCustomers = async () => {
  //   try {
  //     const response = await fetch(`http://${BASE_URL}:8000/api/customers`);
  //     if (!response.ok) {
  //       throw new Error("Failed to fetch customers");
  //     }
  //     const data = await response.json();
  //     console.log("Fetched data:", data);
  //     setCustomers(data.data.customers);
  //   } catch (error) {
  //     console.error("Error fetching customers:", error);
  //   }
  // };

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const reloadCustomers = () => {
    searchCustomer(searchQuery, page).then((value) => {
      setCustomers(value.data.docs);
      setTotal(value.data.totalDocs);
    });
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <Breadcrumbs
          maintitle="Customer List"
          subtitle="Manage Your Customers"
          addButton="Add New Customer"
        />

        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="search"
                    className="form-control form-control-sm formsearch"
                    placeholder="Search By Customer Name"
                    value={searchQuery}
                    onChange={handleSearchInputChange}
                  />
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <CustomerTable
                customers={customers}
                loadCustomer={reloadCustomers}
                setSelectedCustomer={setSelectedCustomer}
                changePage={changePage}
                total={total}
                page={page}
              />
            </div>
          </div>
        </div>
        {/* /product list */}
      </div>
      <CustomerModal
        loadCustomers={reloadCustomers}
        selectedCustomer={selectedCustomer}
        setCustomers={setCustomers}
      />
    </div>
  );
};

export default Customers;
